import { useEffect, useState } from "react";
import api from "@/lib/api";
import NewsCard from "@/components/NewsCard";
import { useUiTexts } from "@/lib/uiTexts";

export default function News() {
  const [articles, setArticles] = useState([]);
  const texts = useUiTexts();

  useEffect(() => {
    api.get("/news").then((r) => setArticles(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="news-page" className="page-enter mx-auto max-w-7xl px-4 py-16 sm:px-8 lg:py-24">
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-orange-500">{texts.news_page_label}</p>
      <h1 className="mt-2 text-2xl font-extrabold uppercase tracking-tight sm:text-3xl lg:text-4xl">{texts.news_page_title}</h1>
      <p className="mt-3 max-w-2xl text-slate-400">
        Toutes les informations importantes de la structure : résultats, tournois, sorties boutique et vie du club.
      </p>
      <div className="mt-10 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {articles.map((a) => <NewsCard key={a.id} article={a} />)}
      </div>
    </div>
  );
}
